
export enum RoleType {
    Admin = 'Admin',
    Analyst = 'Analyst',
    Parent = 'Child',
}

export type UserType = {
  email: string;
  id: string;
  code: number;
  password: string;
};

export type AuthenticatedUser = {
  id: string;
  email: string;
  name: string;
  role: RoleType;
  code?: number;
};